import type { SelectFilterState } from '../../../common/constants/filters/select-filter/types';

export const isSelectFilter = (
	type?: SelectFilterState<string>['type'] | string,
): type is SelectFilterState<string>['type'] => {
	return type === 'single-select' || type === 'multi-select';
};
